import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Login from "./Components/Login";
import Profile from "./Components/Profile";
import Myaccount from "./Components/Myaccount";
import Checkout from "./Components/CheckOut";
import ItemsPage from "./Components/ItemsPage";
import Pagination from "./Components/Pagination";
import { AuthProvider } from "./Components/context/AuthContext";
import ProtectedRoute from "./Components/routes/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Navbar />
        <Routes>

          {/* PUBLIC */}
          <Route path="/checkout/login" element={<Login />} />

          {/* PROTECTED */}
          <Route
            path="/ItemsPage"
            element={
              <ProtectedRoute>
                <ItemsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Myaccount"
            element={
              <ProtectedRoute>
                <Myaccount />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pagination"
            element={
              <ProtectedRoute>
                <Pagination />
              </ProtectedRoute>
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/ItemsPage" />} />

        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;